/** Whether an item is hidden in a specific market. Empty/absent = visible. */
export const isHiddenIn = (
  hiddenInMarkets: string[] | null | undefined,
  marketSurveyId: string
): boolean => !!hiddenInMarkets?.includes(marketSurveyId)

/** True when the item is respondent-facing in at least one market in scope. */
export type MarketVisibilityFilter = (
  hiddenInMarkets: string[] | null | undefined
) => boolean

/** No market scope — keep everything. */
export const visibleInAllMarkets: MarketVisibilityFilter = () => true

/**
 * An empty scope keeps everything — a single-market survey has no market ids,
 * and filtering on a not-yet-loaded list would flash a false "fully translated".
 */
export const visibleInAnyMarket = (
  marketSurveyIds: ReadonlyArray<string>
): MarketVisibilityFilter => {
  if (marketSurveyIds.length === 0) return visibleInAllMarkets
  return (hiddenInMarkets) =>
    marketSurveyIds.some((surveyId) => !isHiddenIn(hiddenInMarkets, surveyId))
}

/**
 * Markets fielded in `languageCode`. Translations are per language, so a
 * question shown only in Austria still needs German.
 */
export const marketsForLanguage = (
  languagesBySurveyId: ReadonlyMap<string, ReadonlyArray<string>>,
  languageCode: string
): string[] =>
  Array.from(languagesBySurveyId.entries())
    .filter(([, languages]) => languages.includes(languageCode))
    .map(([surveyId]) => surveyId)
